import React from 'react';
import { ArrowRightIcon } from '@fronton/icons-react';
import { Link, LinkWithGAClickButton, Section, SectionTitle, Typography } from 'common/components';
import { strictBreakpoints } from 'common/styles/breakpoints';
import { createElementKey } from 'utils';
import { BATHROOM_ELEMENT_BLOCK } from '../../../bathroom-constants';
import {
  newBathroomObjectsCard,
  newBathroomObjectsCardButton,
  newBathroomObjectsCardButtonLink,
  newBathroomObjectsCardContent,
  newBathroomObjectsCardGrid,
  newBathroomObjectsCardImage,
  newBathroomObjectsCardImageContainer,
  newBathroomObjectsCardImageContent,
  newBathroomObjectsCardText,
} from './new-bathroom-objects-styles';
import { CARD_LIST } from './new-bathroom-objects-constants';

export const NewBathroomObjects = () => (
  <Section>
    <SectionTitle>Работаем с разными объектами</SectionTitle>
    <div className={newBathroomObjectsCardGrid}>
      {CARD_LIST.map((card, index) => (
        <LinkWithGAClickButton
          className={newBathroomObjectsCard}
          elementBlock={BATHROOM_ELEMENT_BLOCK}
          elementName="Работаем с разными объектами"
          elementText={`${card.title} / ${card.link.label}`}
          href={card.link.href}
          key={createElementKey('object-card', index)}
          title={card.link.title}
        >
          <div className={newBathroomObjectsCardImageContent}>
            <div className={newBathroomObjectsCardImageContainer}>
              <picture>
                {card.image.srcT && (
                  <source srcSet={card.image.srcT} media={strictBreakpoints['--only-tablet']} />
                )}
                <img alt={card.image.alt} className={newBathroomObjectsCardImage} src={card.image.src} loading="lazy" />
              </picture>
            </div>
            <div className={newBathroomObjectsCardContent}>
              <div className={newBathroomObjectsCardText}>
                <Typography adaptive={false} size="subtitle" variant="l">{card.title}</Typography>
                <Typography adaptive={false} size="body_short" variant="m">{card.description}</Typography>
              </div>
              <div className={newBathroomObjectsCardButton}>
                <Link className={newBathroomObjectsCardButtonLink} href={card.link.href} title={card.link.href}>
                  <Typography size="body_accent" variant="s">{card.link.label}</Typography>
                </Link>
                <ArrowRightIcon type='outline' size='m' color='text-primary' />
              </div>
            </div>
          </div>
        </LinkWithGAClickButton>
      ))}
    </div>
  </Section>
);
